import { render, staticRenderFns } from "./addressManage.vue?vue&type=template&id=039e7155&scoped=true&"
import script from "./addressManage.vue?vue&type=script&lang=js&"
export * from "./addressManage.vue?vue&type=script&lang=js&"
import style0 from "./addressManage.vue?vue&type=style&index=0&id=039e7155&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e7155",
  null
  
)

component.options.__file = "addressManage.vue"
export default component.exports